import { Moment } from 'moment';

export class ConsultaProjetoVO {

  id: number;
  identificacao: string;
  sigla: string;
  nome: string;
  nomeInstituicao: string;
  dataInicio: Moment;
  dataFim: Moment;
  codigoTipoProjeto: number;
  outraEspecificacaoProjeto: string;

  constructor(init?: Partial<ConsultaProjetoVO>) {
    Object.assign(this, init);
  }
}
